/**
 * @file index.tsx
 *
 * @fileoverview Renders privacy policy link.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import MINI_POLICY from '~/jobiqo/components/PrivacyPolicyLink/graphql/queries/miniPolicy.gql';
import { Text } from '~/vcl/atoms/13-text/03-text';

interface PrivacyPolicyLinkProps {
  /**
   * Render only the link, without standalone text alignment wrappers.
   */
  inline?: boolean;
}

interface MiniPolicyMenuItem {
  title: string;
  url: {
    path: string;
  };
  class?: string;
  target?: string;
}

interface MiniPolicyData {
  menu?: {
    items?: MiniPolicyMenuItem[];
  };
}

export const PrivacyPolicyLink = ({
  inline = false,
}: PrivacyPolicyLinkProps) => {
  const { data, error } = useQuery<MiniPolicyData>(MINI_POLICY);

  if (error || !data?.menu?.items?.length) {
    return null;
  }

  const renderLink = (item: MiniPolicyMenuItem, index: number) => (
    <a
      title={item.title}
      key={`${item.url.path}-${index}`}
      className={item.class}
      href={item.url.path}
      target={item.target}
      rel="noreferrer"
    >
      {inline ? item.title.toLowerCase() : item.title}
    </a>
  );

  if (inline) {
    return <>{data.menu.items.map(renderLink)}</>;
  }

  return (
    <>
      {data.menu.items.map((item, index) => (
        <Text key={`${item.url.path}-${index}`} fontSize={2} textAlign="center">
          {renderLink(item, index)}
        </Text>
      ))}
    </>
  );
};
